import { countryRequiresState } from 'Account/hooks';
import { states } from 'Book/shared/data';

export default (country: string) => {
  if (countryRequiresState(country)) {
    return states[country] && states[country].length > 0
      ? states[country].map(state => ({
          label: state.label,
          value: state.value,
        }))
      : [];
  }

  return [];
};
